// ==========================================
// AUTO-GENERATED FROM JAVA ENUM
// Source: Java UserPermission
// DO NOT EDIT MANUALLY - Use sync-java-enums.js
// ==========================================

/**
 * UserPermission enum synchronized from Java
 * Represents feature flags available in the system
 */
export enum UserPermission {
  GEOZONE_VIEW = 'geozone_view',
  GEOZONE_MANAGE = 'geozone_manage',
  GEOZONE_VISIT_VIEW = 'geozone_visit_view',
  GEOZONE_VISIT_RECALCULATE = 'geozone_visit_recalculate',
  MENU_HOME_GEOZONE_OVERVIEW = 'menu_home_geozone_overview',
  MENU_HOME_GEOZONE_LIST = 'menu_home_geozone_list',
  MENU_HOME_GEOZONE_TAGS = 'menu_home_geozone_tags',
  MENU_HOME_GEOZONE_VISIT_LIST = 'menu_home_geozone_visit_list',
  MENU_HOME_LOCATION_HISTORY = 'menu_home_location_history',
  MENU_ADMIN_GEOZONES = 'menu_admin_geozones',
  MENU_ADMIN_GEOZONE_TAGS = 'menu_admin_geozone_tags',
  METAR_WEATHER_LOCATION_VIEW = 'metar_weather_location_view',
  METAR_WEATHER_LOCATION_MANAGE = 'metar_weather_location_manage',
  MENU_ADMIN_METAR_WEATHER_LOCATION = 'menu_admin_metar_weather_location',
  NOTIFICATION_VIEW = 'notification_view',
  NOTIFICATION_MANAGE = 'notification_manage',
  MENU_ADMIN_NOTIFICATION = 'menu_admin_notification',
  INTEGRATED_HELP_VIEW = 'integrated_help_view',
  INTEGRATED_HELP_MANAGE = 'integrated_help_manage',
  MENU_ADMIN_INTEGRATED_HELP = 'menu_admin_integrated_help',
  MAINTENANCE_PROGRAMS_VIEW = 'maintenance_programs_view',
  MAINTENANCE_PROGRAMS_MANAGE = 'maintenance_programs_manage',
  MAINTENANCE_STATE_MANAGE = 'maintenance_state_manage',
  MENU_HOME_MAINTENANCE_OVERVIEW = 'menu_home_maintenance_overview',
  MENU_HOME_MAINTENANCE_PROGRAMS = 'menu_home_maintenance_programs',
  MENU_HOME_UPCOMING_MAINTENANCE = 'menu_home_upcoming_maintenance',
  MENU_HOME_DONE_MAINTENANCE = 'menu_home_done_maintenance',
  MENU_ADMIN_MAINTENANCE = 'menu_admin_maintenance',
  ALERT_RULE_VIEW = 'alert_rule_view',
  ALERT_RULE_MANAGE = 'alert_rule_manage',
  MENU_ADMIN_ALERT_RULE = 'menu_admin_alert_rule',
  USER_VIEW = 'user_view',
  USER_MANAGE = 'user_manage',
  MENU_ADMIN_USERS = 'menu_admin_users',
  IMPERSONATE = 'impersonate',
  IMPERSONATE_SAME_ORG = 'impersonate_same_org',
  ORG_SUPPORT_LOGIN_VIEW_ONLY = 'org_support_login_view_only',
  ORG_SUPPORT_LOGIN_ADMIN = 'org_support_login_admin',
  API_KEY_VIEW = 'api_key_view',
  API_KEY_MANAGE = 'api_key_manage',
  MENU_ADMIN_API_ACCESS = 'menu_admin_api_access',
  OAUTH2_CLIENT_VIEW = 'oauth2_client_view',
  OAUTH2_CLIENT_MANAGE = 'oauth2_client_manage',
  DEVICE_SIGFOX_MESSAGE_VIEW = 'device_sigfox_message_view',
  DEVICE_SIGFOX_MESSAGE_MANAGE = 'device_sigfox_message_manage',
  DEVICE_SERVICE_VIEW = 'device_service_view',
  DEVICE_SERVICE_MANAGE = 'device_service_manage',
  ALERT_VIEW = 'alert_view',
  ALERT_MANAGE = 'alert_manage',
  MENU_HOME_ALERT_ACTIVE_DASHBOARD = 'menu_home_alert_active_dashboard',
  MENU_HOME_ALERT_ACTIVE_LIST = 'menu_home_alert_active_list',
  MENU_HOME_ALERT_HISTORICAL_DASHBOARD = 'menu_home_alert_historical_dashboard',
  MENU_HOME_ALERT_HISTORICAL_LIST = 'menu_home_alert_historical_list',
  DEVICE_UTILIZATION_DATA_VIEW = 'device_utilization_data_view',
  DEVICE_UTILIZATION_DATA_MANAGE = 'device_utilization_data_manage',
  MENU_HOME_DEVICE_UTILIZATION_KPI_LIST = 'menu_home_device_utilization_kpi_list',
  MENU_ADMIN_DEVICE_UTILIZATION_SCHEME = 'menu_admin_device_utilization_scheme',
  INFRASTRUCTURE_VIEW = 'infrastructure_view',
  INFRASTRUCTURE_UPDATE = 'infrastructure_update',
  INFRASTRUCTURE_DELETE = 'infrastructure_delete',
  MENU_ADMIN_INFRASTRUCTURE = 'menu_admin_infrastructure',
  DIAGNOSTIC_VIEW = 'diagnostic_view',
  DIAGNOSTIC_MANAGE = 'diagnostic_manage',
  MENU_ADMIN_DIAGNOSTIC = 'menu_admin_diagnostic',
  SIGFOX_ACCOUNT_VIEW = 'sigfox_account_view',
  SIGFOX_ACCOUNT_MANAGE = 'sigfox_account_manage',
  MENU_ADMIN_SIGFOX_ACCOUNT = 'menu_admin_sigfox_account',
  PROCESS_VIEW = 'process_view',
  PROCESS_MANAGE = 'process_manage',
  MENU_ADMIN_PROCESS_DEFINITION = 'menu_admin_process_definition',
  MENU_HOME_PROCESS_LIST = 'menu_home_process_list',
  AUTOMATION_VIEW = 'automation_view',
  AUTOMATION_MANAGE = 'automation_manage',
  MENU_ADMIN_AUTOMATION = 'menu_admin_automation',
  WIFI_VIEW = 'wifi_view',
  WIFI_MANAGE = 'wifi_manage',
  MENU_ADMIN_WIFI = 'menu_admin_wifi',
  PRIVATE_CELLULAR_VIEW = 'private_cellular_view',
  PRIVATE_CELLULAR_MANAGE = 'private_cellular_manage',
  MENU_ADMIN_PRIVATE_CELLULAR = 'menu_admin_private_cellular',
  HARVESTED_CELLULAR_VIEW = 'harvested_cellular_view',
  MENU_ADMIN_HARVESTED_CELLULAR = 'menu_admin_harvested_cellular',
  CELL_TOWER_TROUBLESHOOTING_VIEW = 'cell_tower_troubleshooting_view',
  CELL_TOWER_TROUBLESHOOTING_MANAGE = 'cell_tower_troubleshooting_manage',
  MENU_ADMIN_CELL_TOWER_TROUBLESHOOTING = 'menu_admin_cell_tower_troubleshooting',
  USER_ROLE_VIEW = 'user_role_view',
  USER_ROLE_MANAGE = 'user_role_manage',
  MENU_ADMIN_USER_ROLE = 'menu_admin_user_role',
  STOCK_VIEW = 'stock_view',
  STOCK_MANAGE = 'stock_manage',
  MENU_ADMIN_STOCK = 'menu_admin_stock',
  STOCK_MOVEMENT_VIEW = 'stock_movement_view',
  MENU_STOCK_MOVEMENT = 'menu_stock_movement',
  BLE_SENSOR_VIEW = 'ble_sensor_view',
  BLE_SENSOR_MANAGE = 'ble_sensor_manage',
  MENU_ADMIN_BLE_SENSOR = 'menu_admin_ble_sensor',
  ORGANISATION_VISIBILITY_FILTER_VIEW = 'organisation_visibility_filter_view',
  ORGANISATION_VISIBILITY_FILTER_MANAGE = 'organisation_visibility_filter_manage',
  MENU_ADMIN_ORGANISATION_VISIBILITY_FILTER = 'menu_admin_organisation_visibility_filter',
  BUSINESS_DATA_VIEW = 'business_data_view',
  BUSINESS_DATA_UPDATE = 'business_data_update',
  BUSINESS_DATA_DELETE = 'business_data_delete',
  BUSINESS_CHANNEL_VIEW = 'business_channel_view',
  BUSINESS_CHANNEL_MANAGE = 'business_channel_manage',
  MENU_ADMIN_BUSINESS_CHANNEL = 'menu_admin_business_channel',
  FLOW_VIEW = 'flow_view',
  FLOW_MANAGE = 'flow_manage',
  MENU_ADMIN_FLOW = 'menu_admin_flow',
  IMAGE_LIBRARY_VIEW = 'image_library_view',
  IMAGE_LIBRARY_MANAGE = 'image_library_manage',
  MENU_ADMIN_IMAGE_LIBRARY = 'menu_admin_image_library',
  GEOLAYER_VIEW = 'geolayer_view',
  GEOLAYER_MANAGE = 'geolayer_manage',
  MENU_ADMIN_GEOLAYER = 'menu_admin_geolayer',
  GEOLAYER_GENERATOR_VIEW = 'geolayer_generator_view',
  GEOLAYER_GENERATOR_MANAGE = 'geolayer_generator_manage',
  MENU_ADMIN_GEOLAYER_GENERATOR = 'menu_admin_geolayer_generator',
  SITE_MAP_VIEW = 'site_map_view',
  SITE_MAP_MANAGE = 'site_map_manage',
  MENU_HOME_SITE_MAP = 'menu_home_site_map',
  MENU_ADMIN_SITE_MAP = 'menu_admin_site_map',
  DASHBOARD_VIEW = 'dashboard_view',
  DASHBOARD_MANAGE = 'dashboard_manage',
  MENU_HOME_DASHBOARD = 'menu_home_dashboard',
  MENU_ADMIN_DASHBOARD = 'menu_admin_dashboard',
  AUDIT_LOG_VIEW = 'audit_log_view',
  MENU_ADMIN_AUDIT_LOG = 'menu_admin_audit_log',
  CUSTOM_I18N_MESSAGE_VIEW = 'custom_i18n_message_view',
  CUSTOM_I18N_MESSAGE_MANAGE = 'custom_i18n_message_manage',
  MENU_ADMIN_CUSTOM_I18N_MESSAGE = 'menu_admin_custom_i18n_message',
  ORDER_VIEW = 'order_view',
  REPORT_TEMPLATE_VIEW = 'report_template_view',
  REPORT_TEMPLATE_MANAGE = 'report_template_manage',
  MENU_ADMIN_REPORT_TEMPLATE = 'menu_admin_report_template',
  ORIENTATION_EVENT_VIEW = 'orientation_event_view',
  ORIENTATION_STATE_VIEW = 'orientation_state_view',
  SHOCK_EVENT_VIEW = 'shock_event_view',
  QUEUE_FIRMWARE_UPGRADE = 'queue_firmware_upgrade',
  SUPPORT_MANAGE = 'support_manage',
  MENU_ADMIN_SUPPORT = 'menu_admin_support',
  ZENDESK_TICKET_VIEW = 'zendesk_ticket_view',
  MENU_ADMIN_ZENDESK_SUPPORT_TICKET = 'menu_admin_zendesk_support_ticket',
  MENU_ADMIN_ZENDESK_ORDER = 'menu_admin_zendesk_order',
  INVOICING_VIEW = 'invoicing_view',
  INVOICING_MANAGE = 'invoicing_manage',
  MENU_ADMIN_BILLING = 'menu_admin_billing',
  MENU_ADMIN_INVOICES = 'menu_admin_invoices',
  PRICE_BOOKS_VIEW = 'price_books_view',
  PRICE_BOOKS_MANAGE = 'price_books_manage',
  MENU_ADMIN_PRICE_BOOKS = 'menu_admin_price_books',
  PRICELIST_VIEW = 'pricelist_view',
  PRICELIST_MANAGE = 'pricelist_manage',
  MENU_ADMIN_PRICELIST = 'menu_admin_pricelist',
  SALESFORCE_CONTACT_VIEW = 'salesforce_contact_view',
  SALESFORCE_CONTACT_MANAGE = 'salesforce_contact_manage',
  MENU_ADMIN_SALESFORCE_CONTACT = 'menu_admin_salesforce_contact',
  SALESFORCE_ACCOUNT_VIEW = 'salesforce_account_view',
  SALESFORCE_ACCOUNT_MANAGE = 'salesforce_account_manage',
  MENU_ADMIN_SALESFORCE_ACCOUNT = 'menu_admin_salesforce_account',
  SALESFORCE_LEAD_VIEW = 'salesforce_lead_view',
  SALESFORCE_LEAD_MANAGE = 'salesforce_lead_manage',
  MENU_ADMIN_SALESFORCE_LEAD = 'menu_admin_salesforce_lead',
  SALESFORCE_OPPORTUNITY_VIEW = 'salesforce_opportunity_view',
  SALESFORCE_OPPORTUNITY_MANAGE = 'salesforce_opportunity_manage',
  MENU_ADMIN_SALESFORCE_OPPORTUNITY = 'menu_admin_salesforce_opportunity',
  SALESFORCE_QUOTE_VIEW = 'salesforce_quote_view',
  SALESFORCE_QUOTE_MANAGE = 'salesforce_quote_manage',
  MENU_ADMIN_SALESFORCE_QUOTE = 'menu_admin_salesforce_quote',
  SALESFORCE_QUOTE_LINE_ITEM_VIEW = 'salesforce_quote_line_item_view',
  SALESFORCE_QUOTE_LINE_ITEM_MANAGE = 'salesforce_quote_line_item_manage',
  MENU_ADMIN_SALESFORCE_QUOTE_LINE_ITEM = 'menu_admin_salesforce_quote_line_item',
  SALESFORCE_CHANNEL_PARTNER_VIEW = 'salesforce_channel_partner_view',
  SALESFORCE_CHANNEL_PARTNER_MANAGE = 'salesforce_channel_partner_manage',
  MENU_ADMIN_SALESFORCE_CHANNEL_PARTNER = 'menu_admin_salesforce_channel_partner',
  SALESFORCE_USER_VIEW = 'salesforce_user_view',
  SALESFORCE_USER_MANAGE = 'salesforce_user_manage',
  MENU_ADMIN_SALESFORCE_USER = 'menu_admin_salesforce_user',
  IMPARTNER_ACCOUNT_VIEW = 'impartner_account_view',
  IMPARTNER_ACCOUNT_MANAGE = 'impartner_account_manage',
  MENU_ADMIN_IMPARTNER_ACCOUNT = 'menu_admin_impartner_account',
  IMPARTNER_CHANNEL_PARTNER_VIEW = 'impartner_channel_partner_view',
  IMPARTNER_CHANNEL_PARTNER_MANAGE = 'impartner_channel_partner_manage',
  MENU_ADMIN_IMPARTNER_CHANNEL_PARTNER = 'menu_admin_impartner_channel_partner',
  IMPARTNER_USER_VIEW = 'impartner_user_view',
  IMPARTNER_USER_MANAGE = 'impartner_user_manage',
  MENU_ADMIN_IMPARTNER_USER = 'menu_admin_impartner_user',
  QUOTE_VIEW = 'quote_view',
  MANAGE_QUOTE = 'manage_quote',
  APPROVE_QUOTE = 'approve_quote',
  QUOTE_MANAGE_SUPER_USER = 'quote_manage_super_user',
  QUOTE_MANAGE_INTERNAL = 'quote_manage_internal',
  LINK_TO_SALESFORCE = 'link_to_salesforce',
  MENU_ADMIN_QUOTES = 'menu_admin_quotes',
  INVOICING_OPERATIONS_VIEW = 'invoicing_operations_view',
  INVOICING_OPERATIONS_MANAGE = 'invoicing_operations_manage',
  MENU_ADMIN_INVOICING_OPERATIONS = 'menu_admin_invoicing_operations',
  RENEWAL_FORECASTS_VIEW = 'renewal_forecasts_view',
  RENEWAL_FORECASTS_MANAGE = 'renewal_forecasts_manage',
  MENU_ADMIN_RENEWAL_FORECASTS = 'menu_admin_renewal_forecasts',
  TRACKER_PRODUCT_VIEW = 'tracker_product_view',
  MENU_ADMIN_TRACKER_PRODUCT = 'menu_admin_tracker_product',
  BATTERY_CALCULATOR_VIEW = 'battery_calculator_view',
  MENU_ADMIN_BATTERY_CALCULATOR = 'menu_admin_battery_calculator',
  WEB_ACCESS = 'web_access',
  APP_ACCESS = 'app_access',
  APP_SEARCH_ONLY = 'app_search_only',
  MISSING_PERMISSION = 'missing_permission',
  STORAGE_SETTING_ACCESS = 'storage_setting_access',
  TIME_SERIES_VIEW = 'time_series_view',
  SYSTEM_ADMIN_VIEW = 'system_admin_view',
  SYSTEM_ADMIN_MANAGE = 'system_admin_manage',
  CSM_VIEW = 'csm_view',
  CSM_MANAGE = 'csm_manage',
  MENU_ADMIN_CSM = 'menu_admin_csm',
  DEVICE_CREATOR = 'device_creator',
  VISIBILITY_FILTER_VIEW = 'visibility_filter_view',
  VISIBILITY_FILTER_MANAGE = 'visibility_filter_manage',
  MENU_ADMIN_VISIBILITY_FILTER = 'menu_admin_visibility_filter',
  CUSTOM_INTERFACE_MANAGE = 'custom_interface_manage',
  MENU_ADMIN_CUSTOM_INTERFACE = 'menu_admin_custom_interface',
  MENU_ADMIN_LANDING_PAGE = 'menu_admin_landing_page',
  SUBSCRIPTION_VIEW = 'subscription_view',
  SUBSCRIPTION_MANAGE = 'subscription_manage',
  SUBSCRIPTION_AUTORENEW = 'subscription_autorenew',
  SUBSCRIPTION_SELF_CREATE = 'subscription_self_create',
  SUBSCRIPTION_SELF_EXTEND = 'subscription_self_extend',
  MANUFACTURING = 'manufacturing',
  PLATFORM_PLAN_VIEW = 'platform_plan_view',
  PLATFORM_PLAN_MANAGE = 'platform_plan_manage',
  MENU_ADMIN_PLATFORM_PLAN = 'menu_admin_platform_plan',
  MENU_ADMIN_INTERNAL_PLATFORM_PLAN = 'menu_admin_internal_platform_plan',
  ORGANIZATION_VIEW = 'organization_view',
  ORGANIZATION_MANAGE = 'organization_manage',
  MENU_ADMIN_ORGANIZATION_SSO = 'menu_admin_organization_sso',
  MENU_ADMIN_ORGANIZATION_DETAILS = 'menu_admin_organization_details',
  MENU_ADMIN_ORGANIZATION_LIST = 'menu_admin_organization_list',
  RMA_DECLARATION_MANAGE = 'rma_declaration_manage',
  MENU_ADMIN_RMA_DECLARATION = 'menu_admin_rma_declaration',
  DEMO_VIEW = 'demo_view',
  DEMO_MANAGE = 'demo_manage',
  MENU_ADMIN_DEMO = 'menu_admin_demo',
  DEVICE_HW_DEBUG = 'device_hw_debug',
  DEVICE_PROVISION = 'device_provision',
  DEVICE_DEBUG = 'device_debug',
  DEVICE_ASSIGN = 'device_assign',
  DEVICE_HIST_DATA_VIEW = 'device_hist_data_view',
  DEVICE_HIST_DATA_DELETE = 'device_hist_data_delete',
  DEVICE_DELETE = 'device_delete',
  DEVICE_METADATA_VIEW = 'device_metadata_view',
  DEVICE_UPDATE = 'device_update',
  ASSET_LOCATION_CHECKIN = 'asset_location_checkin',
  MENU_ADMIN_SYSTEM_TAGS = 'menu_admin_system_tags',
  MENU_ADMIN_PARTNER_TAGS = 'menu_admin_partner_tags',
  MENU_ADMIN_ASSET_TAGS = 'menu_admin_asset_tags',
  DEVICE_MARK_FOR_REPLACEMENT = 'device_mark_for_replacement',
  DEVICE_PERFORM_REPLACEMENT = 'device_perform_replacement',
  MENU_ADMIN_BULK_OPERATION = 'menu_admin_bulk_operation',
  MENU_ADMIN_TRACKERS = 'menu_admin_trackers',
  MENU_ADMIN_EOL_TRACKERS = 'menu_admin_eol_trackers',
  MENU_HOME_ASSET_LIST = 'menu_home_asset_list',
  MENU_HOME_TAGS = 'menu_home_tags',
  MENU_HOME_ASSET_MAP = 'menu_home_asset_map',
  THIRD_PARTY_DEVELOPER_VIEW = 'third_party_developer_view',
  MENU_HOME_CUSTOM_DATA_LIST = 'menu_home_custom_data_list',
  THIRD_PARTY_DEVELOPER_MANAGE = 'third_party_developer_manage',
  MENU_ADMIN_API_DOCS = 'menu_admin_api_docs',
  MENU_ADMIN_CLIENT_APP_API = 'menu_admin_client_app_api',
  MENU_ADMIN_WEBHOOKS = 'menu_admin_webhooks',
  MENU_ADMIN_WEBHOOK_OVERVIEWS = 'menu_admin_webhook_overviews',
  MENU_ADMIN_INTERNAL_API = 'menu_admin_internal_api',
  REPORTING_VIEW = 'reporting_view',
  REPORTING_MANAGE = 'reporting_manage',
  MENU_HOME_REPORT_LIST = 'menu_home_report_list',
  REPORT_SCHEDULER_VIEW = 'report_scheduler_view',
  REPORT_SCHEDULER_MANAGE = 'report_scheduler_manage',
  MENU_HOME_REPORT_SCHEDULES = 'menu_home_report_schedules',
  USAGE_PROFILE_VIEW = 'usage_profile_view',
  USAGE_PROFILE_MANAGE = 'usage_profile_manage',
  USAGE_PROFILE_MANAGE_VISIBLE_ALL = 'usage_profile_manage_visible_all',
  MENU_ADMIN_USAGE_PROFILE = 'menu_admin_usage_profile',
  PARTNER_MANAGE = 'partner_manage',
  PARTNER_VIEW = 'partner_view',
  MENU_ADMIN_PARTNERS = 'menu_admin_partners',
  MENU_ADMIN_PARTNER_DETAIL = 'menu_admin_partner_detail',
  DEVICE_REMOTE_SETTING_MANAGE = 'device_remote_setting_manage',
  DEVICE_REMOTE_SETTING_VIEW = 'device_remote_setting_view',
  DEVICE_ACTIVATE = 'device_activate',
  PRODUCT_AUTO_UPGRADE_VIEW = 'product_auto_upgrade_view',
  PRODUCT_AUTO_UPGRADE_MANAGE = 'product_auto_upgrade_manage',
  MENU_ADMIN_PRODUCT_AUTO_UPGRADE = 'menu_admin_product_auto_upgrade',
  PRODUCT_REGEXP_FILTER_VIEW = 'product_regexp_filter_view',
  PRODUCT_REGEXP_FILTER_MANAGE = 'product_regexp_filter_manage',
  MENU_ADMIN_PRODUCT_REGEXP_FILTER = 'menu_admin_product_regexp_filter',
  CELLULAR_ACCOUNT_VIEW = 'cellular_account_view',
  CELLULAR_ACCOUNT_MANAGE = 'cellular_account_manage',
  MENU_ADMIN_CELLULAR_ACCOUNT = 'menu_admin_cellular_account',
  CELLULAR_SIM_VIEW = 'cellular_sim_view',
  MENU_ADMIN_CELLULAR_SIM = 'menu_admin_cellular_sim',
  MENU_ADMIN_BLE_TAG_TRACKING_SETTINGS = 'menu_admin_ble_tag_tracking_settings',
  MANAGE_BLE_TAG_TRACKING_SETTINGS = 'manage_ble_tag_tracking_settings',
  EDIT_ORGANIZATION_IBEACON_UUID = 'edit_organization_ibeacon_uuid',
  AI_CHAT_USE = 'ai_chat_use',
  MANAGE_AI_PROMPTS = 'manage_ai_prompts',
  MENU_ADMIN_AI_PROMPTS = 'menu_admin_ai_prompts',
  MANAGE_AI_CHATS = 'manage_ai_chats',
  MENU_ADMIN_AI_CHATS = 'menu_admin_ai_chats',
  TEAMLEADER_CALLBACK = 'teamleader_callback',
  FIRMWARE_TESTING = 'firmware_testing',
  MOBILE_MENU_HOME_FAVORITES = 'mobile_menu_home_favorites',
  MOBILE_MENU_HOME_NEARBY = 'mobile_menu_home_nearby',
  MOBILE_MENU_HOME_ASSET_MAP = 'mobile_menu_home_asset_map',
  MOBILE_MENU_HOME_ASSET_LIST = 'mobile_menu_home_asset_list',
  MOBILE_MENU_HOME_DASHBOARD = 'mobile_menu_home_dashboard',
  MOBILE_MENU_HOME_TAGS = 'mobile_menu_home_tags',
  MOBILE_MENU_HOME_GEOZONE_LIST = 'mobile_menu_home_geozone_list',
  MOBILE_MENU_HOME_ALERT_ACTIVE_LIST = 'mobile_menu_home_alert_active_list',
  MOBILE_MENU_ADMIN_BLE_TRACKERS = 'mobile_menu_admin_ble_trackers',
  MOBILE_MENU_ADMIN_BLE_SENSOR = 'mobile_menu_admin_ble_sensor',
  MOBILE_MENU_ADMIN_BLE_GEOBEACON = 'mobile_menu_admin_ble_geobeacon',
  MOBILE_MENU_ADMIN_BULK_CHECKIN = 'mobile_menu_admin_bulk_checkin',
  MOBILE_MENU_ADMIN_FIRMWARE_UPGRADE = 'mobile_menu_admin_firmware_upgrade',
  MOBILE_MENU_ADMIN_FL4300_CONFIG = 'mobile_menu_admin_fl4300_config',
  MOBILE_MENU_ADMIN_DEVICE_CREATION = 'mobile_menu_admin_device_creation',
  MOBILE_MENU_ADMIN_INFRASTRUCTURE = 'mobile_menu_admin_infrastructure',
  MOBILE_DEVICE_DETAIL_IDCARD = 'mobile_device_detail_idcard',
  MOBILE_DEVICE_DETAIL_GEOLOCATION = 'mobile_device_detail_geolocation',
  MOBILE_DEVICE_DETAIL_GEOZONES = 'mobile_device_detail_geozones',
  MOBILE_DEVICE_DETAIL_ACTIVITY = 'mobile_device_detail_activity',
  MOBILE_DEVICE_DETAIL_ALERTS = 'mobile_device_detail_alerts',
  MOBILE_DEVICE_DETAIL_BUSINESS_DATA = 'mobile_device_detail_business_data',
  MOBILE_DEVICE_DETAIL_ORIENTATION_STATE = 'mobile_device_detail_orientation_state',
  MOBILE_DEVICE_DETAIL_ORIENTATION_EVENT = 'mobile_device_detail_orientation_event',
  MOBILE_DEVICE_DETAIL_MAINTENANCE = 'mobile_device_detail_maintenance',
  MOBILE_DEVICE_DETAIL_EXTERNAL_SENSORS = 'mobile_device_detail_external_sensors',
  MOBILE_DEVICE_DETAIL_NETWORK_COMMUNICATION = 'mobile_device_detail_network_communication',
  MOBILE_DEVICE_DETAIL_SUBSCRIPTION = 'mobile_device_detail_subscription',
  MOBILE_DEVICE_DETAIL_BATTERY = 'mobile_device_detail_battery',
  MOBILE_DEVICE_DETAIL_CONFIGURATION = 'mobile_device_detail_configuration',
  MOBILE_DEVICE_DETAIL_RAW_MESSAGES = 'mobile_device_detail_raw_messages',
  MOBILE_DEVICE_DETAIL_FIRMWARE = 'mobile_device_detail_firmware',
  MOBILE_DEVICE_DETAIL_BLE_ACTIONS = 'mobile_device_detail_ble_actions',
  EMAIL_SEND = 'email_send'
}

/**
 * Type helper for UserPermission values
 */
export type UserPermissionValue = `${UserPermission}`;

/**
 * Get all UserPermission values as array
 */
export const getUserPermissionValues = (): UserPermission[] => {
  return Object.values(UserPermission);
};

/**
 * Check if value is valid UserPermission
 */
export const isValidUserPermission = (value: unknown): value is UserPermission => {
  return typeof value === 'string' && Object.values(UserPermission).includes(value as UserPermission);
};
